import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { fetchGroups } from '../../apis/GroupAPI';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Loading from '../../components/Loading';
import ErrorMessage from '../../components/ErrorMessage';
import DisplayAndCreate from '../../components/DisplayAndCreate';
import Header from '../../components/HomeNavigation';

import '../../../css/components/listAndCreate.css';
import NavigationLayout from '../../components/Layouts/NavigationLayout';

const styles = {
  main: {
    marginLeft: '12%',
    marginRight: '12%'
  }
};

class Groups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      groups: null
    };
  }

  componentDidMount = async () => {
    await this.initialise();
  };

  initialise = async () => {
    const { match } = this.props;
    try {
      const groups = await fetchGroups(match.params.channelId);
      this.setState({ groups });
    } catch (error) {
      this.setState({ error: true });
    }
  };

  render() {
    const { error, groups } = this.state;
    const { match } = this.props;

    if (!groups) {
      return error ? <ErrorMessage /> : <Loading />;
    }

    return (
      <NavigationLayout>
        <div>
          <Header isTitle={true} isOperatorHome={false} isGroupHome={true} />
          <DisplayAndCreate
            id="create-group"
            title={<h2>Groups</h2>}
            style={styles.main}
            createButtonText="Create groups"
            {...this.props}
          >
            <List>
              {groups.map((group, index) => (
                <Link key={group.id} to={`${match.url}/${group.name}`}>
                  <ListItem button id={'group-' + index}>
                    <ListItemText
                      primary={group.name}
                      secondary={group.languages.join(', ')}
                    />
                  </ListItem>
                </Link>
              ))}
            </List>
          </DisplayAndCreate>
        </div>
      </NavigationLayout>
    );
  }
}

export default Groups;
